import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() titulo: string; // ok
  @Input() texto = ''; // ok
  /* tslint:disable-next-line:no-input-rename */
  @Input('id') itemId?: number; // ok
  @Input() tipo?: string; // ok
  @Input() eixo?: string;
  @Input() eixos?: [];
  @Input() eixoNome?: string;
  @Input() cursoAtual?: string;
  cursoMsg: string = null; // ok
  cardTipo: string;
  encurtarTexto = true; // ok
  bgColor: string;
  displayMoreBtn: boolean;

  constructor() { }

  ngOnInit(): void {
    this.organizeCardData();
  }

  organizeCardData(): void {
    if (this.tipo === 'cursomudounome' || this.tipo === 'mudaramnome') {
      this.cursoMsg = 'Possível convergência';
      this.cardTipo = 'mudouNome';
      this.bgColor = 'bg-color-orange';
    } else if (this.tipo === 'cursonaopermitido' || this.tipo === 'naopermitidos') {
      this.cursoMsg = 'Curso excluído ou não incluído';
      this.cardTipo = 'excluido';
      this.bgColor = 'bg-color-red';
    } else if (this.tipo === 'experimentais') {
      this.cursoMsg = 'Curso em oferta experimental';
      this.cardTipo = 'experimental';
      this.bgColor = 'bg-color-blue';
    }
  }

  displayBtn(text: string): boolean {
    const textLength = text.replace(/\<.*?\>(.*?)\<\/.*?\>/gi, '$1').length;
    return textLength > 144 ? true : false;
  }
}
